export default __webpack_public_path__ + "static/media/nf_2.6de9736c.png";